import React from 'react'
import './FloatingDiv.css'

const FloatingDiv = ({image, txt1}) => {

  return (
    <div className="floatingdiv">
        <img src={image} alt="" />
        <span>
            {txt1}
        </span>
    </div>
  )
}

export default FloatingDiv